/** Chart hover tooltips — always use these, never bg-gray-900 / bg-white (gray ramp inverts in dark mode). */
export const CHART_TOOLTIP_CLASS =
  'chart-tooltip pointer-events-none absolute z-10 rounded-md px-3 py-2 text-xs shadow-lg';

export const chartTooltipHtml = {
  title: 'chart-tooltip__title',
  row: 'chart-tooltip__row',
  rowInner: 'chart-tooltip__row-inner',
  label: 'chart-tooltip__label',
  value: 'chart-tooltip__value',
  muted: 'chart-tooltip__muted',
  dot: 'chart-tooltip__dot',
  swatch: 'chart-tooltip__swatch',
  grid: 'chart-tooltip__grid',
} as const;
